import type { TFunction } from 'i18next'

import type { DecisionAction } from '~/pages/AdminApprovalTasks/models/approvalDecisionFailure'
import type { ApproverIdentity } from '~/pages/SpotBidding/models/approverIdentity'

/**
 * 承認者でない人・申請者本人への確認モーダルの文 (AC-APT-019a)。 承認者以外は入札画面と同じ文、
 * 自己承認はモーダル用に「このまま承認 / 差戻しますか？」 で終える文。 両方に当たる時は
 * 承認者以外 → 自己承認の順に並べる。 先頭の文を Alert の見出し、 残りを説明にする
 * (8080 プロトの `approval-guard.js`)。
 */
export function buildApproverGuardMessages(
  identity: ApproverIdentity,
  action: DecisionAction,
  t: TFunction,
): string[] {
  const isApprove = action === 'approve'
  return [
    ...(identity.isNotApprover
      ? [
          t(
            isApprove
              ? 'page:biddingSpot.approverWarning.notApproverConfirmApprove'
              : 'page:biddingSpot.approverWarning.notApproverConfirmReject',
          ),
        ]
      : []),
    ...(identity.isSelfApproval
      ? [
          t(
            isApprove
              ? 'page:adminApprovalTasks.guardModal.selfApprovalConfirmApprove'
              : 'page:adminApprovalTasks.guardModal.selfApprovalConfirmReject',
          ),
        ]
      : []),
  ]
}
